import PageHead from '../../../../components/PageHead'
import HeaderArtist from '../../components/HeaderArtist'
import Image from 'next/legacy/image'
import styles from '../_artistPage.module.scss'
import tabStyles from '../../../../components/_tab.module.scss'
import Link from 'next/link'
import {
  albumPath,
  albumsPath,
  artistPath,
  artistSongsPath
} from '../../../../utils/routeHelpers'
import { t } from '../../../../utils'
import dynamic from 'next/dynamic'
import { useRouter } from 'next/router'
import classNames from 'classnames'
import { Artist } from '../../../../__generated__/graphql'

const Header = dynamic(() => import('../../../../components/Header'))
const Footer = dynamic(() => import('../../../../components/Footer'))

const ArtistLayout: React.FC<{
  artist: Artist
  children?: React.ReactNode
}> = ({ artist, children }) => {
  const coverImage = artist.cover.medium
  const router = useRouter()

  const { album_id } = router.query
  const album = artist.albums.find((a) => a.id.toString() === album_id)

  return (
    <>
      <PageHead
        title={artist.name}
        description={`${artist.name} full band tutorial videos. Download high quality chord charts and tabs in any key. Learn to play songs like the album.`}
        thumbnail={artist.picture.medium}
      />
      <div className={styles.artistPageHeader}>
        <Image
          priority={true}
          src={coverImage}
          alt={artist.name}
          className={styles.coverImage}
          layout="fill"
        />
        <div className={`container ${styles.artistHeaderInner}`}>
          <Header hasSearch={true} />
          <HeaderArtist artist={artist} album={album} />
        </div>
      </div>
      <div className={`container ${styles.artistPageContainer}`}>
        <main>
          <div className={styles.tabs}>
            {artist.description && (
              <Link
                href={artistPath(artist)}
                prefetch={false}
                className={classNames(
                  tabStyles.tab,
                  router.asPath === artistPath(artist) && tabStyles.tabIsActive
                )}
              >
                <span>{t('About')}</span>
              </Link>
            )}

            <Link
              href={artistSongsPath(artist)}
              prefetch={false}
              className={classNames(
                tabStyles.tab,
                router.asPath === artistSongsPath(artist) &&
                  tabStyles.tabIsActive
              )}
            >
              <span>{t('Songs')}</span>
            </Link>

            <Link
              href={albumsPath(artist)}
              prefetch={false}
              className={classNames(
                tabStyles.tab,
                router.asPath === albumsPath(artist) && tabStyles.tabIsActive
              )}
            >
              <span
                className={
                  album &&
                  router.asPath === albumPath(album) &&
                  'is-text-purple'
                }
              >
                {t('Albums')}
              </span>
            </Link>
            {album && (
              <Link
                href={albumPath(album)}
                prefetch={false}
                className={classNames(
                  styles.tabAlbumName,
                  tabStyles.tab,
                  router.asPath === albumPath(album) && tabStyles.tabIsActive,
                  router.asPath === albumPath(album) &&
                    styles.tabAlbumNameActive
                )}
              >
                <span>{album.name}</span>
              </Link>
            )}
          </div>
          {children}
        </main>
      </div>
      <Footer />
    </>
  )
}
export default ArtistLayout
